// extracted by css-extract-rspack-plugin
export default {"container":"j0xoe","title":"FyS1e","number":"vHW04","description":"TPJev","image":"NbnF_"};